import type { FC } from 'react';
import styles from '../styles/console-completion.module.scss';
import ActionButton from '../components/action-button';
import TitleBox from '../components/title-box';

const ConsoleCompletion: FC<{
    confirmationId?: string;
    onClose: () => void;
    onLogout: () => void;
}> = ({ confirmationId, onClose, onLogout }) => {
    return (
        <div className={styles.consoleCompletion}>
            <div className={styles.completeTitle}>操作が完了しました</div>
            {confirmationId && <TitleBox title={`予約番号：${confirmationId}`} />}
            <ActionButton className={styles.actionButton} title="予約管理TOPへ" onClick={onClose} />
            <ActionButton
                className={styles.actionButton}
                title="ログアウトする"
                primary={false}
                onClick={onLogout}
            />
        </div>
    );
};

export default ConsoleCompletion;
